module.exports = __webpack_public_path__ + "static/dagny-bold-56affc48e8c3c7728eacb760c3ed9f98.woff2";